import {collection, component, EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";
import {CategoryReferenceData} from "../category/category.data";

export class PlgSellableCompositeProductProductLineData extends EntityData<PlgSellableCompositeProductProductLineData> {
    @identifier sellableId: number;
    @field name: string;
    @field discontinued: boolean;
}

export class PlgSellableCompositeProductProductLineQtyData extends EntityData<PlgSellableCompositeProductProductLineQtyData> {
    @component productLine: PlgSellableCompositeProductProductLineData;
}

export class PlgSellableCompositeProductData extends EntityData<PlgSellableCompositeProductData> {
    @identifier sellableId: number;
    @collection(PlgSellableCompositeProductProductLineQtyData) prodLineQuantities: PlgSellableCompositeProductProductLineQtyData[];
}

export class PlgSellableSellableData extends EntityData<PlgSellableSellableData> {
    @field sellableType: string;
    @identifier sellableId: number;
    @field name: string;
    @field price: number;
    @field plu: string;
    @field discontinued: boolean;
}

export class PlgSellableData extends EntityData<PlgSellableData> {
    @component sellable: PlgSellableSellableData;
    @field defaultSellable: boolean;
    @field additionalPrice: number;

    get available(): boolean {
        return !this.sellable.discontinued;
    }
}

export class PlgData extends EntityData<PlgData> {
    @identifier plgId: number;
    @field name: string;
    @field externalName: string;
    @field description: string;
    @component primaryCategory: CategoryReferenceData;
    @field icon: string;
    @field promptForPlgSelections: boolean = true;

    @collection(PlgSellableData) sellableLines: PlgSellableData[];
}
